import gql from "graphql-tag";

const EDITORIAL = gql`
  query Editorial($id: ID!) {
    editorial(where: { id: $id }) {
      id
      startDate
      endDate
      name
      transactions
      revenue
      customers
      clicks
      domain
      url
      byDate {
        transactions
        revenue
        customers
        clicks
        date
      }
      clicksTag {
        id
        orgs(first: 1) {
          website
        }
      }
      transactionsTag {
        id
      }
      reports(orderBy: createdAt_DESC, first: 1) {
        id
        key
      }
    }
  }
`;

export default EDITORIAL;
